<div
  id="select-company"
  class="select-company-tree"
  tabindex="-1"
  #panelRoot
  (click)="$event.stopPropagation()"
  (keydown.tab)="$event.stopPropagation()"
>
  <div class="company-menu-header">
    @if (treeService.initialStatus() === 'error') {
      <div id="errorBox" class="alert alert-danger tw-mb-[10px]" role="alert">
        <strong>{{ treeService.initialErrorMessage() }}</strong>
      </div>
    }
    <div class="company-menu-header__controls">
      <button
        mat-icon-button
        type="button"
        id="select-parent-company-button"
        class="company-menu-header__parent"
        [matTooltip]="parentCompanyLabel()"
        matTooltipClass="menu-tooltip"
        [attr.aria-label]="parentCompanyLabel()"
        (click)="selectParentCompany()"
      >
        <mat-icon svgIcon="company" aria-hidden="true"></mat-icon>
      </button>
      <search-filter
        [filterConfig]="filterConfig"
        [search]="searchService.search"
        [focus]="true"
        [doSearch]="searchService.doSearch"
      ></search-filter>
      <mat-slide-toggle
        id="show-all-companies-toggle"
        labelPosition="before"
        [checked]="treeService.showAllCompanies()"
        (change)="onShowAllCompaniesChange($event.checked)"
      >
        Show all companies
      </mat-slide-toggle>
    </div>
  </div>
  <div class="select-company-tree__body" #treeScrollRoot>
    @if (showSpinner()) {
      <div
        id="select-company-list-spinner"
        class="tw-flex tw-justify-center tw-items-center tw-h-[128px] tw-bg-white/60"
      >
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
    }
    @if (mode() === 'tree' && treeService.initialStatus() === 'loaded') {
      <company-tree
        [scrollRoot]="treeScrollRoot"
        (selectCompany)="closeMenu.emit()"
      ></company-tree>
    }
    @if (mode() === 'search') {
      <company-search-results
        (selectCompany)="closeMenu.emit()"
      ></company-search-results>
    }
    <!-- Mounted rather than wrapped in `@if`: the message replaces the load
         spinner once focus is already in the search field, and a live region
         inserted at that moment is not reliably announced. -->
    <p class="tw-sr-only" role="status">{{ pagingMessage() }}</p>
  </div>
  <div class="company-menu-footer">
    <a
      mat-button
      uiSref="apps.company.add"
      id="add-subcompany-menu-button"
      (click)="closeMenu.emit()"
    >
      <div class="tw-flex tw-gap-[12px] tw-items-center">
        <mat-icon svgIcon="add" class="small medium"></mat-icon>
        <span>Add Sub-Company</span>
      </div>
    </a>
    <button
      mat-button
      type="button"
      (click)="licenseManagement()"
      id="company-licenses-button"
    >
      <div
        class="tw-flex tw-gap-[12px] tw-items-center tw-justify-between tw-w-full"
      >
        <div class="tw-flex tw-gap-[12px] tw-items-center">
          <mat-icon
            svgIcon="hierarchy"
            class="small medium"
            aria-hidden="true"
          ></mat-icon>
          <span>Companies &amp; Licenses</span>
        </div>
        @if (!companyAccessService.accessCompanyLicenses) {
          <mat-icon
            class="small"
            svgIcon="requires-upgrade"
            id="company-licenses-requires-upgrade"
            aria-hidden="true"
          ></mat-icon>
          <span class="tw-sr-only">Requires upgrade</span>
        }
      </div>
    </button>
  </div>
</div>
